import Button from "@/common/components/Button";
import { formatDate, formatDateTime } from "@/common/utils/formatters";
import { ArrowBigRight } from "lucide-react";
import { Link } from "react-router-dom";
import { AnpReportData } from "../types/anpReports.type";

export class AnpReportsTransformer {
  static tableTransformer({
    basePath = '/anp-reports',
    showActions = true,
    operationKlass = "Establishment::Anp::Reports::Show"
  }: { basePath?: string; showActions?: boolean, operationKlass?: string } = {}) {
    return (reports: AnpReportData[]) => (
      reports.map((report) => ({
        ...report,
        _className: !report.approved_at ? 'bg-yellow-op-2' : undefined,
        initial_date: report.initial_date && formatDate(new Date(report.initial_date)),
        end_date: report.end_date && formatDate(new Date(report.end_date)),
        approved_at: report.approved_at ? formatDateTime(new Date(report.approved_at)) : '--',
        actions: showActions ? (
          <Link to={`${basePath}/${report.id}`} className="inline-flex items-center">
            <Button
              variant="link-white"
              className="w-full"
              operationKlassToCheckPermission={operationKlass}
            >
              <ArrowBigRight />
            </Button>
          </Link>
        ) : null,
      }))
    );
  }
}
